import { Reducer } from 'redux';
import _ from 'lodash';
import { IReduxAction } from 'app/types/actions';
import {
  DashboardActionTypes as types,
  IDashboardState,
} from './types';

const initialState: IDashboardState = {
  teamSelection: {
    id: 'all-teams',
    name: 'All Teams',
  },
  hideUpcomingMatches: false,
};

const reducer: Reducer<IDashboardState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.UPDATE_DASHBOARD_CONFIG: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
